export const PermissionType = {
    lab: ["Settings", "Patient", "Cliche", "LabPage", "Tutorial"],
    note: ["Settings", "Note", "Tutorial"],
    application: ["Application", "Settings", "Tutorial"],
    admin: ["Settings", "Report", "Note", "LabPage", "Application", "HR", "Patient", "Firebase", "Cliche", "Tutorial"],
    Secretary: ["Settings", "Patient", "Tutorial", "LabPage"],
};

export const RoleHome = {
    lab: "/LabPage",
    note: "/Note",
    application: "/",
    admin: "/Patient",
    Secretary: "/Patient",
};

export function normalizeRole(role) {
    if (!role) return "";
    const cleaned = String(role).trim();
    const match = Object.keys(PermissionType).find((key) => key.toLowerCase() === cleaned.toLowerCase());
    return match || cleaned;
}

export function canAccessMenu(role, key) {
    return PermissionType[normalizeRole(role)]?.includes(key) === true;
}

export function getRoleHome(role) {
    return RoleHome[normalizeRole(role)] || "/Settings";
}

export function isAllowedRole(role, allowedRoles = []) {
    const normalized = String(role || "").toLowerCase();
    return allowedRoles.some((allowed) => String(allowed).toLowerCase() === normalized);
}
